export default __webpack_public_path__ + "static/things-you-will-know-if-youve-backpacked-hero-image-2611b14d797fcc051a4aff0c152c790a.jpg";